import { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { AuthUtil } from "../../../utils/auth";
import { useAuthContextV2 } from "../../../auth-state";
import { ServiceProviderR } from "../../pages/service-provider/routes";
import { EnvNavBarTag } from "../../molecules/env-tag";
import corporateLogoWhite from "../../../assets/corporate_logo_white.svg";

export const ServiceProviderHeader = withRouter(({ history }) => {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const { syncAuth } = useAuthContextV2();

  const logout = async () => {
    await AuthUtil.logout();
    await syncAuth();
    history.push("/service-provider/login");
  };

  return (
    <nav className="navbar has-shadow c-header-wrapper">
      <div className="navbar-brand c-header-hoverable">
        <Link to={ServiceProviderR.Home.link({})} className="navbar-item">
          <img src={corporateLogoWhite} alt="株式会社グラファー 会社ロゴ" />
          &nbsp; &nbsp;
        </Link>
        <EnvNavBarTag />
        <div
          className={`navbar-burger burger ${isMenuActive ? "is-active" : ""}`}
          data-target="navMenu"
          onClick={() => setIsMenuActive(isMenuActive)}
        >
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className={`navbar-menu ${isMenuActive ? "is-active" : ""}`}>
        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons">
              <button className="button is-light" onClick={logout}>
                ログアウト
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
});
